// 프레일 평가·노쇠지수 조회. 실패해도 화면은 그대로 뜬다 — 이 카드는 덤이다.
//
// 응답은 서버(src/server/frail/router.js)가 사람이 읽을 글까지 붙여 준다.
// 화면은 점수를 다시 계산하지 않는다.

import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/config';

export default function useFrail(appUserId) {
    const [state, setState] = useState({ data: null, loading: true, error: null });

    useEffect(() => {
        if (!appUserId) return undefined;
        let cancelled = false;
        (async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${API_BASE_URL}/api/patients/${appUserId}/frail`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (!cancelled) setState({ data: response.data || null, loading: false, error: null });
            } catch (error) {
                if (!cancelled) setState({ data: null, loading: false, error });
            }
        })();
        return () => { cancelled = true; };
    }, [appUserId]);

    return state;
}
